import { gql } from '@apollo/client';

import { WorkOrderScopeFields } from './WorkOrderScope';

export const WorkOrderFields = gql`
  fragment WorkOrderFields on OdProtosHomeworkData_WorkOrder {
    id
    state
    costCents
    acceptedCostCents
    kind
    address {
      uuid
      street
      city
      state
      postalCode
      unitType
      unitNumber
      marketData {
        shorthand_identifier
      }
    }
    assignedToBranch {
      id
      displayName
      organization {
        name
        email
        primaryPhone
      }
      capabilities {
        capabilityType
      }
      compliance {
        complianceStatus
      }
      vendor {
        name
      }
    }
    lineItemIds
    lineItems {
      accountCategory
    }
    projectId
    latestAcceptedWorkOrderScope {
      ...WorkOrderScopeFields
    }

    latestManagerProposedWorkOrderScope {
      ...WorkOrderScopeFields
    }
    initialWorkOrderScope {
      ...WorkOrderScopeFields
    }

    workOrderScopes {
      ...WorkOrderScopeFields
    }
    accountingBuckets
    accountingClosedAt
    referenceNumber
  }
  ${WorkOrderScopeFields}
`;
